import React from 'react';
import 'VENDOR/CommonResources/NotFound/notfound.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

class NotFound extends React.Component {
    render() {
        return(
            <div className="errorPage">
                <p className="error-msg">
                    The link you are trying to access is either not available or you might not have access.
                </p>
                <Link to="/">
                    <span className="home-button">
                        <FontAwesomeIcon className="home-icon icon" icon={['fas', 'home']} size="lg" style={{ marginRight: 5 }} /> 
                        Go back in home page
                    </span>
                </Link>
            </div>
        );
    }
}

export default NotFound;